import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SafeNavigationGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean {
    const nav = this.router.getCurrentNavigation();

    if (nav?.extras.state?.['fromInsideApp']) {
      // Allowed to display the unauthorized message if we came via router.navigate(['/unauthorized'], { state: { fromInsideApp: true } })
      return true;
    } else if (nav?.previousNavigation?.extractedUrl.queryParams['error'] == 'access_denied') {
      //Allowed to display the unauthorized message
      return true;
    } else {
      // Otherwise redirect to home page or somewhere safe
      this.router.navigate(['/']);
      return false;
    }
  }
}
